import React, { useMemo } from 'react';
import { DayScale } from './scale';

// Week-boundary lines always render. Day gridlines render too at Week/Detail
// zoom; Overview hides them when the range exceeds 60 days, to avoid grid
// noise (the caller decides `dayLinesEnabled` since that decision needs the
// zoom level *and* the day count together).
export const GridLines = React.memo(
  ({
    scale,
    height,
    dayLinesEnabled,
    dayColor,
    weekColor
  }: {
    scale: DayScale;
    height: number;
    dayLinesEnabled: boolean;
    dayColor: string;
    weekColor: string;
  }) => {
    const lines = useMemo(() => {
      const out: { key: string; x: number; color: string }[] = [];
      const step = dayLinesEnabled ? 1 : 7;
      const firstBoundary = Math.ceil(scale.dayMin / step) * step;
      for (let d = firstBoundary; d <= scale.dayMax + 1; d += step) {
        const isWeekBoundary = ((d % 7) + 7) % 7 === 0;
        out.push({
          key: `grid-${d}`,
          // The closing boundary lands at exactly totalWidth; its 1px width
          // would poke past the canvas and trip a scrollbar. Clamp so the last
          // line sits just inside the right edge.
          x: Math.min(scale.xOfDayEdge(d), scale.totalWidth - 1),
          color: isWeekBoundary ? weekColor : dayColor
        });
      }
      return out;
    }, [scale, dayLinesEnabled, dayColor, weekColor]);

    return (
      <>
        {lines.map((l) => (
          <div
            key={l.key}
            style={{
              position: 'absolute',
              left: l.x,
              top: 0,
              width: 1,
              height,
              background: l.color
            }}
          />
        ))}
      </>
    );
  }
);
